module.exports = __webpack_public_path__ + "img/ea84469.png";